export const adminTokens = {
  pink: '#ff0066',
  ink: '#172021',
  muted: '#7d8586',
  line: '#e7eae9',
  green: '#23886a',
  canvas: '#f5f7f6',
  nav: '#63706c',
  navLabel: '#929997',
  activeBg: '#fff0f5',
  badgeBg: '#fce6ee',
  paper: '#ffffff',
  sidebar: 224,
  rail: 70
};
